import { SaudiRiyal } from '../components/SVGIcons/SaudiRiyal';
import { SaudiRiyalLarge } from '../components/SVGIcons/SaudiRiyalLarge';
import { Currency } from './enum';

export const CURRENCY_SYMBOLS: Record<Currency, string> = {
  [Currency.AED]: Currency.AED,
  [Currency.BHD]: Currency.BHD,
  [Currency.KWD]: Currency.KWD,
  [Currency.OMR]: Currency.OMR,
  [Currency.QAR]: Currency.QAR,
  [Currency.SAR]: Currency.SAR,
  [Currency.GBP]: '£'
};

export const CURRENCY_LOCALES: Record<Currency, string> = {
  [Currency.AED]: 'en-AE',
  [Currency.BHD]: 'en-BH',
  [Currency.KWD]: 'en-KW',
  [Currency.OMR]: 'en-OM',
  [Currency.QAR]: 'en-QA',
  [Currency.SAR]: 'en-SA',
  [Currency.GBP]: 'en-GB'
};

export const getCurrencyIcon = (currency: Currency, size: 'small' | 'large' = 'small') => {
  if (currency === Currency.SAR) {
    return size === 'large' ? SaudiRiyalLarge : SaudiRiyal;
  }
  return null;
};

export const formatCurrency = (
  amount: number,
  currency: Currency,
  options?: Intl.NumberFormatOptions
): string => {
  if (!amount || isNaN(amount)) {
    return 'N/A';
  }

  const locale = CURRENCY_LOCALES[currency];
  const defaultOptions: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 3
  };

  try {
    return new Intl.NumberFormat(locale, { ...defaultOptions, ...options }).format(amount);
  } catch {
    const symbol = CURRENCY_SYMBOLS[currency];
    return `${symbol}${amount.toFixed(2)}`;
  }
};

export const getCurrencySymbol = (currency: Currency): string => CURRENCY_SYMBOLS[currency] || currency;

export const formatAmountWithSymbol = (amount: number, currency: Currency): string => {
  if (!amount || isNaN(amount)) {
    return 'N/A';
  }

  const symbol = getCurrencySymbol(currency);
  return `${symbol}${amount.toFixed(2)}`;
}; 